module.exports = __webpack_public_path__ + "mk.8f27127c99505bd359bd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mk.svg
// module chunks = styles